<template>
  <v-card
    class="mx-auto card-menu d-flex align-center mb-5"
    max-width="400"
    height="155"
    hover
    @click="handleRedirect(pathName)"
  >
    <v-card-text class="white--text text-center">
      <v-icon v-text="icon" color="white" x-large /> <br>
      <span class="text-h5">
        {{ text }}
      </span>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    pathName: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleRedirect(pathName) {
      this.$router.push({ name: pathName })
    }
  }
}
</script>
<style lang="sass" scoped>
.card-menu
  transition: all .2s ease-in-out
  &:hover
    transform: scale(1.1)
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2)
</style>
